import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, Phone } from 'lucide-react';
import { Button } from './ui/button';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Home', href: '/' },
    { name: 'About', href: '/#about' },
    { name: 'Services', href: '/#services' },
    { name: 'Menu', href: '/#menu' },
    { name: 'Matchday Catering', href: '/matchday-catering' },
    { name: 'Careers', href: '/careers' },
    { name: 'Contact', href: '/#contact' }
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-white/95 backdrop-blur-sm'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <div className="text-2xl font-bold" style={{ color: 'var(--accent-ui-accent)' }}>
              Marlowes Catering
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            {navLinks.map((link) => (
              <a
                key={link.name}
                href={link.href}
                className="text-sm font-medium hover:opacity-70 transition-opacity"
                style={{ color: 'var(--text-base)' }}
              >
                {link.name}
              </a>
            ))}
          </nav>

          {/* CTA Button */}
          <div className="hidden md:flex items-center space-x-4">
            <a href="tel:01612228831" className="flex items-center space-x-2 hover:opacity-80 transition-opacity">
              <Phone size={18} style={{ color: 'var(--accent-ui-accent)' }} />
              <span className="text-sm font-medium" style={{ color: 'var(--accent-ui-accent)' }}>
                0161 222 8831
              </span>
            </a>
            <Button
              onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}
              style={{ backgroundColor: 'var(--accent-ui-accent)', color: 'white' }}
            >
              Get a Quote
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-2"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="Toggle menu"
          >
            {isMobileMenuOpen ? (
              <X size={24} style={{ color: 'var(--accent-ui-accent)' }} />
            ) : (
              <Menu size={24} style={{ color: 'var(--accent-ui-accent)' }} />
            )}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden py-4 border-t">
            <nav className="flex flex-col space-y-4">
              {navLinks.map((link) => (
                <a
                  key={link.name}
                  href={link.href}
                  className="text-sm font-medium hover:opacity-70 transition-opacity"
                  style={{ color: 'var(--text-base)' }}
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  {link.name}
                </a>
              ))}
              <a href="tel:01612228831" className="flex items-center space-x-2">
                <Phone size={18} style={{ color: 'var(--accent-ui-accent)' }} />
                <span className="text-sm font-medium" style={{ color: 'var(--accent-ui-accent)' }}>
                  0161 222 8831
                </span>
              </a>
              <Button
                onClick={() => {
                  document.getElementById('contact').scrollIntoView({ behavior: 'smooth' });
                  setIsMobileMenuOpen(false);
                }}
                style={{ backgroundColor: 'var(--accent-ui-accent)', color: 'white' }}
                className="w-full"
              >
                Get a Quote
              </Button>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;